<template>
    <form>
        <div class="justify-content-center flex-nowrap">
            <div class="card">
                <div class="card-header">
                    <div class="text-center mb-2">
                        <a class="text-center mb-4">{{this.question.Text}}</a>
                    </div>
                    <!--<a>{{this.answer}}</a>-->
                    <div class="text-center">
                        <span class="mx-2">
                            <label :for="'ans-1_' + this.phaseQuestion.QuestionId">Nicht relevant</label>
                            <input 
                                :id="'ans-1_' + this.phaseQuestion.QuestionId"
                                name="scoreInput"
                                type="radio"
                                value="-1"
                                v-model="answer.Score"
                                required/>
                        </span>
                        <span class="mx-2">
                            <label :for="'ans0_' + this.phaseQuestion.QuestionId">Nein</label>
                            <input 
                                :id="'ans0_' + this.phaseQuestion.QuestionId"
                                name="scoreInput"
                                type="radio"
                                value="0"
                                v-model="answer.Score"
                                required/>
                        </span>
                        <span class="mx-2">
                            <label :for="'ans1_' + this.phaseQuestion.QuestionId">In Planung</label>
                            <input 
                                :id="'ans1_' + this.phaseQuestion.QuestionId"
                                name="scoreInput"
                                type="radio"
                                value="1"
                                v-model="answer.Score"
                                required/>
                        </span>
                        <span class="mx-2">
                            <label :for="'ans2_' + this.phaseQuestion.QuestionId">Vereinzelt/Pilotprojekte</label>
                            <input 
                                :id="'ans2_' + this.phaseQuestion.QuestionId"
                                name="scoreInput"
                                type="radio"
                                value="2"
                                v-model="answer.Score"
                                required/>
                        </span>
                        <span class="mx-2">
                            <label :for="'ans3_' + this.phaseQuestion.QuestionId">Ausgeprägt</label>
                            <input 
                                :id="'ans3_' + this.phaseQuestion.QuestionId"
                                name="scoreInput"
                                type="radio"
                                value="3"
                                v-model="answer.Score"
                                required/>
                        </span>
                        <span class="mx-2">
                            <label :for="'ans4_' + this.phaseQuestion.QuestionId">Vollumfänglich umgesetzt/Automatisiert</label>
                            <input 
                                :id="'ans4_' + this.phaseQuestion.QuestionId"
                                name="scoreInput"
                                type="radio"
                                value="4"
                                v-model="answer.Score"
                                required/>
                        </span>
                    </div>
                    <div class="form-row align-items-center">
                        <div class="col-sm" />
                        <div class="col mx-2">
                            <input
                                class="form-control text-center"
                                type="text"
                                placeholder="Kommentar hier eintragen"
                                name="commentInput"
                                v-model="answer.Comment"            
                            />
                        </div>
                        <div class="col-sm" />
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import axios from 'axios';

export default {
    name: "QuestionInput",
    components: {

    },
    props: {
        phaseQuestion: {}
    },
    emits: ["updatedAnswerHandler", "loadedQuestionHandler", "submittedAnswerHandler"],
    //watch triggers on changing the prop value, where the binding is done.
    //the prop value is changed for already created QuestionInput, when navigating to a new page. -> MM - 2022-07-19
    watch: {
        phaseQuestion: function(newValue, oldValue) {
            console.log("Watch on prop in QuestionInput with questionId = " + this.question.Id + " triggered.");
            this.fetchAnswerAndQuestion();
        }
    },
    data: function() {
        return {
            answer: {},
            question: {},
            tmpAnswer: {},
            questionAnswered: false            
        }
    },
    created() {
        this.fetchAnswerAndQuestion();
    },
    updated() {       
        //console.log("Update on QuestionInput with questionId = " + this.question.Id + " triggered.");

        if((this.answer.Score != this.tmpAnswer.Score) || (this.answer.Comment != this.tmpAnswer.Comment)) {
            this.tmpAnswer = JSON.parse(JSON.stringify({...this.answer}));
            this.$emit("updatedAnswerHandler", this.answer);

            if(this.questionAnswered == false) {
                this.questionAnswered = true;
                this.$emit("submittedAnswerHandler", this.answer);
            }
        }
    },
    methods: {
        /*fetchAnswer() {
            axios
                .get("/api/getAnswer/" + this.phaseQuestion.PhaseId + "/" + this.phaseQuestion.QuestionId)
                .then(response => {                   
                    this.answer = response.data;
                    this.tmpAnswer = JSON.parse(JSON.stringify({...this.answer}));  
                    //console.log("fetched answer:");
                    //console.log(this.answer);                                                        
                })
                .catch(
                    //err => console.log(err)
                );
        },
        fetchQuestion() {
            axios
                .get("/api/question/" + this.phaseQuestion.QuestionId)
                .then(response => {                   
                    this.question = response.data;                    
                    console.log("fetched question:");
                    console.log(this.question);                                                        
                })
                .catch(
                    //err => console.log(err)
                );
        },*/
        fetchAnswerAndQuestion(){            
            axios
                .all([axios.get("/api/question/" + this.phaseQuestion.QuestionId),
                axios.get("/api/getAnswer/" + this.phaseQuestion.PhaseId + "/" + this.phaseQuestion.QuestionId)
                ])
                .then(axios.spread((...responses) => {
                    this.question = responses[0].data;
                    console.log("this.question:");
                    console.log(this.question);
                    this.answer = responses[1].data;
                    console.log("this.answer:");
                    console.log(this.answer);
                    this.tmpAnswer = JSON.parse(JSON.stringify({...this.answer}));
                    this.$emit("loadedQuestionHandler", true);
                    if(this.answer.Score == -2) {
                        this.questionAnswered = false;
                    } else {
                        this.questionAnswered = true;
                        this.$emit("submittedAnswerHandler", this.answer);
                    }
                    
                }))
                .catch(
                    //err => console.log(err)
                );
        }
    }
}
</script>